import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'radio-button-specs',
  templateUrl: './radio-button-specs.component.html',
  styleUrls: ['./radio-button-specs.component.sass']
})
export class RadioButtonSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/radio-button/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }
}
